import { useState, useEffect } from 'react';

function readColumnCount(node) {
  const value = window.getComputedStyle(node).gridTemplateColumns;
  if (!value || value === 'none') return 1;
  return value.split(' ').filter(Boolean).length;
}

export function useCategoryGridColumns(gridRef) {
  const [columnCount, setColumnCount] = useState(1);

  useEffect(() => {
    const node = gridRef.current;
    if (!node) return undefined;

    const measure = () => setColumnCount(readColumnCount(node));

    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(node);
    return () => observer.disconnect();
  }, [gridRef]);

  return columnCount;
}
